import { Generic } from './Heading';
export function isHeading(node) {
    return node !== null && typeof node === 'object' && node instanceof Generic;
}
export default isHeading;    //# sourceMappingURL=isHeading.js.map
